// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-fullwidth/carousel-fullwidth.component.scss
// module id = 420
// module chunks = 0